module.exports = __webpack_public_path__ + "img/DecisionTreeBGGRank.311788bf.png";